import { HttpParams } from "@angular/common/http";

export class CompanyCriteria {
  filterActive: string = 'active';
  searchTerm: string = null;
  pageSize: number = 20;
  page: number = 1;
  orderby: string = 'CreatedAt desc';

  paramsExport(): HttpParams {
    let params = new HttpParams()
      .set('page', String(this.page))
      .set('orderby', this.orderby)
      .set('pageSize', String(this.pageSize));

    if (this.searchTerm && this.filterActive == 'active') {
      params = params.set('filter', 'IsActive == True and (AddressTown.Contains("' + this.searchTerm + '") or Name.Contains("' + this.searchTerm + '"))');
    }  

    if (this.searchTerm && this.filterActive == 'inActive') {
      params = params.set('filter', 'IsActive == False and (AddressTown.Contains("' + this.searchTerm + '") or Name.Contains("' + this.searchTerm + '"))')
    }

    if (this.searchTerm && this.filterActive == 'all') {
      params = params.set('filter', 'AddressTown.Contains("' + this.searchTerm + '") or Name.Contains("' + this.searchTerm + '")')
    }

    if (!this.searchTerm && this.filterActive == 'active') {
      params = params.set('filter', 'IsActive == True') 
    }

    if (!this.searchTerm && this.filterActive == 'inActive') { 
      params = params.set('filter', 'IsActive == False')
    }

    return params;
  }
}
